import React, { useMemo } from 'react';
import { Card, Icon } from '@design-manager-inc/ui';
import { motion } from 'framer-motion';
import { useSearchParams } from 'react-router-dom';
import { useGetMoodBoards } from 'api/hooks/useGetMoodBoards';
import { ActionItems } from 'features/Layout/PageActions';
import { useStackAnimation } from 'app/hooks/useStackAnimation';
import { useAuth } from 'app/features/auth/useAuth';
import { useLayout } from 'app/features/Layout/hooks/useLayout';
import { usePageViewed } from 'app/features/Analytics/hooks/usePageViewed';
import { PAGES } from 'app/features/Analytics/utils/constants';
import { MoodBoardCard } from './partials/MoodBoardCard';

export const MoodBoards = () => {
	usePageViewed(PAGES.MOODBOARDS);
	const { org } = useAuth();
	const [searchParams] = useSearchParams();
	const token = searchParams.get('token') || '';
	const { data: moodBoards, isLoading } = useGetMoodBoards(token);

	useLayout(
		{
			header: {
				title: `Mood Boards ${org?.project?.name ? `for ${org?.project?.name}` : ''}`,
				icon: 'square-3-stack-3d',
				actions: [],
			},
		},
		useMemo(() => [moodBoards], [moodBoards]),
	);

	const motionProps = useStackAnimation(0.3, !isLoading);

	if (moodBoards && moodBoards.length > 0) {
		return (
			<ActionItems title="Mood Boards to Review">
				{moodBoards.map((moodBoard, index) => (
					<motion.div
						key={moodBoard.id}
						initial={motionProps.initial}
						animate={motionProps.animate}
						custom={index}
						className="w-full"
					>
						<MoodBoardCard moodBoard={moodBoard} token={token} />
					</motion.div>
				))}
			</ActionItems>
		);
	}

	if (isLoading) {
		return null;
	}

	return (
		<Card className="h-full flex flex-col rounded-xl p-4 bg-background w-fit md:rounded-3xl lg:rounded-3xl md:p-5 lg:p-5">
			<div className="h-full gap-1 flex flex-col items-center text-center">
				<Icon
					name="check-circle"
					size="lg"
					className="text-primary mb-4 fill-primary-badge"
				/>

				<h3 className="text-lg font-semibold text-text">
					No Mood Boards To Display
				</h3>
				<p className="text-sm text-gray-500">
					Check back later for new updates.
				</p>
			</div>
		</Card>
	);
};

MoodBoards.displayName = 'MoodBoards';
